export default function AppSection() {
  return (
    <section id="app" className="py-14 md:py-20 bg-background-100">
      <div className="w-full px-4 md:px-6">
        <div className="max-w-5xl mx-auto">
          <div className="flex flex-col lg:flex-row items-center gap-8 lg:gap-14 bg-background-50 rounded-2xl p-8 md:p-12">
            <div className="flex-1 text-center lg:text-left">
              <span className="inline-flex items-center gap-1.5 px-3 py-1.5 bg-accent-100 text-accent-700 text-sm font-medium rounded-full mb-4 whitespace-nowrap">
                <i className="ri-smartphone-line text-base"></i>
                多端畅享
              </span>
              <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-900 mb-4">
                随时随地，畅快吃瓜
              </h2>
              <p className="text-sm md:text-base text-foreground-600 leading-relaxed mb-6">
                吃瓜网51提供网页版、正式版与移动端全平台访问方式。无论您是在电脑前工作还是手机刷屏追剧，都能随时随地打开吃瓜网51官方首页入口，第一时间获取最新鲜的娱乐资讯。界面适配各尺寸屏幕，流畅不卡顿，让吃瓜不再受设备限制。
              </p>
              <div className="flex flex-col sm:flex-row items-center justify-center lg:justify-start gap-3">
                <div className="flex items-center gap-3 bg-background-100 rounded-xl px-5 py-3">
                  <div className="w-10 h-10 flex items-center justify-center rounded-lg bg-primary-100">
                    <i className="ri-computer-line text-xl text-primary-600"></i>
                  </div>
                  <div className="text-left">
                    <span className="block text-sm font-medium text-foreground-800 whitespace-nowrap">网页版</span>
                    <span className="block text-xs text-foreground-500 whitespace-nowrap">浏览器直接访问</span>
                  </div>
                </div>
                <div className="flex items-center gap-3 bg-background-100 rounded-xl px-5 py-3">
                  <div className="w-10 h-10 flex items-center justify-center rounded-lg bg-accent-100">
                    <i className="ri-smartphone-line text-xl text-accent-600"></i>
                  </div>
                  <div className="text-left">
                    <span className="block text-sm font-medium text-foreground-800 whitespace-nowrap">移动适配</span>
                    <span className="block text-xs text-foreground-500 whitespace-nowrap">手机端流畅浏览</span>
                  </div>
                </div>
              </div>
            </div>
            <div className="flex-shrink-0">
              <div className="w-48 md:w-56 aspect-[9/16] bg-background-200 rounded-2xl overflow-hidden border-4 border-background-200">
                <img
                  src="https://readdy.ai/api/search-image?query=Modern%20smartphone%20displaying%20entertainment%20news%20app%20interface%20with%20warm%20color%20scheme%20clean%20Chinese%20mobile%20UI%20design%20minimal%20layout%20editorial%20style%20soft%20lighting&width=360&height=640&seq=app-mobile-preview&orientation=portrait"
                  alt="吃瓜网51移动端访问界面 - 手机浏览娱乐资讯"
                  className="w-full h-full object-cover"
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}